import { useEffect } from "react";
import { initLenis, destroyLenis } from "../lib/scroll";

export function useLenis() {
    useEffect(() => {
        initLenis();
        return () => destroyLenis();
    }, []);
}
